const translations = {
  brand: 'Notysing Dashboard',
  home: 'Home',
  logout: 'Log out',
  account: 'Account',
  createdStudents: 'Created Students',
};

export default translations;
